export default __webpack_public_path__ + "static/media/AllGuides.ee7b9a7f.svg";